import React from 'react'

interface Props {
  children: React.ReactNode
}

// Shared sticky CTA footer for the recovery modals.
export const RecoveryModalFooter = ({ children }: Props) => (
  <div className='recoveryModalFooter'>{children}</div>
)

export default RecoveryModalFooter
